import { render, staticRenderFns } from "./ItemNominaPension.vue?vue&type=template&id=3671ecad&"
import script from "./ItemNominaPension.vue?vue&type=script&lang=js&"
export * from "./ItemNominaPension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports